import { Route } from '@angular/router';
import { SheetTemplatesComponent } from './sheet-templates.component';
import { SheetTemplatesListComponent } from './list/list.component';
import { SheetTemplatesDetailsComponent } from './details/details.component';
import { SheetTemplatesResolver, SheetTemplatesSheetTemplateResolver } from './sheet-templates.resolvers';

export const sheetTemplatesRoutes: Route[] = [
  {
    path: '',
    component: SheetTemplatesComponent,
    children: [
      {
        path: '',
        component: SheetTemplatesListComponent,
        resolve: {
          sheetTemplates: SheetTemplatesResolver,
        },
      },
      {
        path: ':id',
        component: SheetTemplatesDetailsComponent,
        resolve: {
          sheetTemplate: SheetTemplatesSheetTemplateResolver,
        },
      },
    ],
  },
];
